const action = {
    $pay: $('button[form="contract-payment-form"]'),
    $verify: $('button[form="contract-verify-form"]'),
    $sum_accept: $('#js-sum-accept-btn'),
    $pay_today: $('#js-pay-today button'),
    $pay_full: $('#js-pay-full button'),
    $close_notice: $('button.close-notice'),
    $sum_edit: $('#js-sum-edit > button')
}

let cookies, is_switch, isPaused = null

$(window).on({
    load: function (event) {
        if(event.currentTarget.location.pathname === '/quickpay/') {
            if(parsedQuery.contract_num === null || parsedQuery.birthdate === null) {
                $('.contract_verify_page').removeClass('invisible')
            } else {
                $('#overlay').removeClass('d-none')
                $('.notice').removeClass('d-none')
                sendAjaxForm('contract-verify-form', `${ajaxData.url}?action=contract_verification`, 'GET', true, parsedQuery)
                isPaused = false
            }
        }
        deleteAllCookies()
    }
})

const check_cookies = setInterval(() => {
    if(isPaused === false) {
        cookies = getCookie()
    }
}, 1000)

const payment_btns = setInterval(() => {
    if(isPaused === false) {
        if(cookies !== undefined && cookies.sbp === '1') {
            $('#js-pay-sbp-btn').removeClass('d-none')
            $('#js-payment-title').text('Выберите способ оплаты')
            is_switch = true
        }
    }
}, 1000)

setTimeout(() => {
    if(is_switch === true) {
        clearInterval(payment_btns)
    }
    if(cookies !== undefined) {
        clearInterval(check_cookies)
    }
}, 120000)


action.$verify.on({
    click: function () {
        isPaused = false
        setTimeout(() => {
            if(!$('#cv-birthday').hasClass('input-error') && !$('#cv-contract_num').hasClass('input-error')) {
                $('#overlay').removeClass('d-none')
                $('.notice').removeClass('d-none')

                sendAjaxForm('contract-verify-form', `${ajaxData.url}?action=contract_verification`, 'GET')
                return false
            }
        }, 1)
    }
})

action.$pay.on({
    click: function () {
        if($(this).attr('id') === 'js-pay-card-btn') {
            $('input[name="payment_by_card"]').attr('value', 'on')
            if($(window).width() < 768) {
                $('.processing-form').css('height', '100%')
            }
        }

        setTimeout(() => {
            $('input[form="contract-payment-form"]').each(function () {
                if(!$(this).hasClass('input-error')) {
                    $('#overlay').removeClass('d-none')
                    $('.payment_request').removeClass('d-none')
                    sendAjaxForm('contract-payment-form', `${ajaxData.url}?action=contract_payment`)
                    return false
                }
            })
        }, 1)
    }
})

action.$sum_accept.on({
    click: function () {
        const $isSbp = getCookie().sbp === '1'
        const $sum = $('#cp-sum')
        if($sum.val() < 100) {
            $('#js-pay-card-btn').attr('disabled', true)
            $('#js-pay-sbp-btn').attr('disabled', true)
            $(`label.valid_sum_info`).removeClass('d-none')
                .text(`100 руб. - минимально допустимая сумма`)
                .css('fontSize', '12px')
                .show()
        } else {
            $(`label.valid_sum_info`).hide()
            $('#js-pay-card-btn').removeAttr('disabled')
            if($isSbp) {
                $('#js-pay-sbp-btn').removeAttr('disabled')
            }
            $('#js-pay-today-sum').text(`${$sum.val()} ₽`)
            $('#contract-payment-form').toggleClass('visually-hidden')
            $('#js-sum-edit').toggleClass('visually-hidden')
        }
    }
})
action.$pay_today.on('click', function () {
    $('#cp-sum').val(cookies.total_today_sum)
    $('#js-pay-today-sum').text(`${cookies.total_today_sum} ₽`)
})
action.$pay_full.on('click', function () {
    $('#cp-sum').val(cookies.total_balance)
    $('#js-pay-today-sum').text(`${cookies.total_balance} ₽`)
})

action.$close_notice.on({
    click: function () {
        deleteAllCookies()
        window.open(window.origin + '/quickpay', '_self');
    }
})

action.$sum_edit.on({
    click: function () {
        $('#contract-payment-form').toggleClass('visually-hidden')
        $('#js-sum-edit').toggleClass('visually-hidden')
    }
})
